/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum HomeWidgetState {
  COLLAPSED = "COLLAPSED",
  EXPANDED = "EXPANDED",
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: HomeWidgetsQuery
// ====================================================

export interface HomeWidgetsQuery_userPreferences_homeWidgets {
  id: string;
  state: HomeWidgetState;
  __typename: "HomeWidget";
}

export interface HomeWidgetsQuery_userPreferences {
  homeWidgets: HomeWidgetsQuery_userPreferences_homeWidgets[];
  __typename: "UserPreferences";
}

export interface HomeWidgetsQuery {
  userPreferences: HomeWidgetsQuery_userPreferences;
}
